import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { Login } from '@/features/auth/components/templates/login/login';

const loginSearchSchema = z.object({
  returnUrl: fallback(z.string(), '/').default('/'),
});

export const Route = createFileRoute('/(auth)/login')({
  component: Login,
  validateSearch: zodValidator(loginSearchSchema),
});
